import { render, staticRenderFns } from "./GeneralDataTab.vue?vue&type=template&id=026287ba"
import script from "./GeneralDataTab.vue?vue&type=script&lang=js"
export * from "./GeneralDataTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralDataTab.vue?vue&type=style&index=0&id=026287ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports